import { createContext, useContext } from 'react';
export function createContextFactory(name) {
    const context = createContext(undefined);
    context.displayName = name;
    function useHook() {
        const t = useContext(context);
        if (!t) {
            throw new Error(`Attempted to use context outside of <${name}Provider /> scope.`);
        }
        return t;
    }
    return [context.Provider, useHook];
}
//# sourceMappingURL=context_factory.js.map